import React from 'react';
type Tome = {
  number: string;
  title: string;
  range: string;
  promise: string;
  badge: string;
  badgeText: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Set Up & Start Strong',
  range: 'Weeks 1–8 · 8 classes',
  promise: 'Put the system in place and get every gymnast moving safely on all four apparatus from day one.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  flag: 'Start here',
  contents: ['The Class-Ready System: how one hour runs itself', 'The 4-Station Flow: rotations solo or with helpers', 'The 5 body shapes every skill needs', 'Safe landings you can teach on day one']
}, {
  number: '02',
  title: 'Build the Basics',
  range: 'Weeks 9–17 · 9 classes',
  promise: 'Clean, confident basics on floor, bars, beam and vault.',
  badge: 'bg-indigo',
  badgeText: 'text-white',
  contents: ['The Progression Ladder and The Drill Stack', 'Forward roll to a clean stand, backward roll power', 'Bridges and the pullover on bars', 'Beam jumps & dip-steps, squat-on vault']
}, {
  number: '03',
  title: 'Connect & Combine',
  range: 'Weeks 18–26 · 9 classes',
  promise: 'Handstands, cartwheels and the first skills linked into short sequences.',
  badge: 'bg-teal',
  badgeText: 'text-white',
  contents: ['Handstand at the wall, cartwheel across the floor', 'Back hip circle and glide swing on bars', 'Low-beam cartwheel, straddle-on vault', 'The Link-Up Method: a 3-skill floor line']
}, {
  number: '04',
  title: 'Level Up',
  range: 'Weeks 27–35 · 9 classes',
  promise: 'The big skills of the rec level, built rung by rung.',
  badge: 'bg-amber',
  badgeText: 'text-ink',
  contents: ['Round-off power and round-off rebound', 'Backbend & kickover', 'Bars link: pullover, cast, circle + underswing dismount', 'Cartwheel on the beam, handstand flatback vault']
}, {
  number: '05',
  title: 'Polish & Perform',
  range: 'Weeks 36–44 · 9 classes',
  promise: 'Form, flow and short routines your gymnasts are proud to show.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  contents: ['The Routine Builder: short routines on every apparatus', 'Connect two tumbling skills', 'Vault handspring prep (lead-ups only)', 'Dress rehearsal and presentation']
}, {
  number: '06',
  title: 'Show, Assess & Sustain',
  range: 'Weeks 45–52 · 8 classes',
  promise: 'A parent showcase, progress you can show, and the tools to run next year.',
  badge: 'bg-indigo',
  badgeText: 'text-white',
  contents: ['The Showcase Blueprint, run-sheet included', 'Assessment stations, badges & the Progress Tracker', 'Games library and the master mixed-level guide', 'The Keep-It-Fresh System to plan next year']
}];
const everyVolume = ['Weekly classes as 2-page spreads: Rotation Map + Skill Spotlight', 'Worksheets you print and reuse (31 in the pack)', 'Class Formula for 30, 45 and 60-minute slots', 'Coach’s Notes, Quick Wins and Spotting & Safety Notes'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white text-ink" data-id="element-383" data-mp="16itwzgeptn71">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-384" data-mp="1ak5ndo5eycga">
        <div className="text-center" data-id="element-385" data-mp="dx212krr0e6b">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-indigo" data-id="element-386" data-mp="dtwebc6ldodr">Your whole year</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-387" data-mp="ispq9068d7bt">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-slate" data-id="element-388" data-mp="royrmkdrqg0l">
            52 weekly classes in the order you teach them, each volume building on
            the last. One group? Go through it across the year. Several groups?
            Open the volume that fits each group&apos;s level.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-389" data-mp="3c5rlqo7qffd6">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-soft ${tome.flag ? 'border-coral ring-1 ring-coral' : 'border-cloud-dark'}`} data-id="element-390" data-mp="376y54mx5f88s">
              <div className="flex items-center gap-2.5" data-id="element-391" data-mp="3ux26enmv6vwm">
                <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-base font-extrabold ${tome.badge} ${tome.badgeText}`} data-id="element-392" data-mp="3pzitbr1wkp69">
                  {tome.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-slate" data-id="element-393" data-mp="3rsozkcxrpym">Volume {tome.number}</span>
                {tome.flag && <span className="ml-auto rounded-full bg-coral px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-394" data-mp="2akd0w6982t0a">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 font-display text-xl font-extrabold leading-tight tracking-tight text-ink" data-id="element-395" data-mp="q0zfxaov9g3w">{tome.title}</h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-coral-deep" data-id="element-396" data-mp="bajqtktbxo0g">{tome.range}</p>
              <p className="mt-2 text-sm text-slate" data-id="element-397" data-mp="g93htzms5pzo">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-cloud-dark pt-4" data-id="element-398" data-mp="2an8e0xj9ldu">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-399" data-mp="6e1p6ttaq5sc">
                    <span className={`mt-[7px] h-1.5 w-1.5 flex-none rounded-full ${tome.badge}`} data-id="element-400" data-mp="3oj4yyru7j5z3" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-6 rounded-2xl bg-ink px-5 py-5 text-white sm:px-7" data-id="element-401" data-mp="1monlkt7qrg6k">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-402" data-mp="1rpbbtco5bszq">In every volume</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-403" data-mp="1q9z6xmy7qytt">
            {everyVolume.map(item => <li key={item} className="flex gap-2 text-[13px] text-white/85" data-id="element-404" data-mp="1lbntz3cmg87d">
                <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-teal" data-id="element-405" data-mp="1gaqg32yna0bo" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}